import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '网红塌房', path: '/category/wanghong-tafang' },
  { name: '明星八卦', path: '/category/mingxing-bagua' },
  { name: '热门事件', path: '/category/remen-shijian' },
  { name: '独家爆料', path: '/category/dujia-baoliao' },
  { name: '实时追踪', path: '/category/shishi-zhuizong' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
      role="navigation"
      aria-label="主导航"
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0 cursor-pointer" aria-label="吃瓜51网首页">
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-accent-500 rounded-lg">
                <span className="font-heading font-black text-base md:text-lg text-foreground-950 leading-none">瓜</span>
              </div>
            <span className="font-heading font-black text-lg md:text-xl text-foreground-950 tracking-tight whitespace-nowrap">
              吃瓜<span className="text-accent-600">51</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 text-sm font-label font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-accent-600 bg-accent-100'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-5 py-2 text-sm font-label font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={mobileOpen}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 bg-background-50/95 backdrop-blur-md pb-4">
            <div className="flex flex-col gap-1 pt-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2.5 text-sm font-label font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    location.pathname === link.path
                      ? 'text-accent-600 bg-accent-100'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="mt-2 mx-4 px-5 py-2.5 text-sm font-label font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}